/* eslint-disable */
import * as Types from './types';

import { HtmlContentFragmentDoc } from './ModuleHtmlContent';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type StaticPageHtmlQueryVariables = Types.Exact<{
  handle: Types.Scalars['String'];
  locale?: Types.InputMaybe<Types.Scalars['String']>;
  preview?: Types.InputMaybe<Types.Scalars['Boolean']>;
  tagFilter?: Types.InputMaybe<Types.StaticPageFilter>;
}>;


export type StaticPageHtmlQuery = { __typename?: 'Query', staticPageCollection?: { __typename?: 'StaticPageCollection', items: Array<{ __typename?: 'StaticPage', sectionsCollection?: { __typename: 'StaticPageSectionsCollection', items: Array<{ __typename: 'BlogArticleStep' } | { __typename: 'BlogArticleTextImage' } | { __typename: 'CollectionFeaturedListingSection' } | { __typename: 'CollectionListingSection' } | { __typename: 'CollectionVideoSection' } | { __typename: 'ColorSelector' } | { __typename: 'ComponentsgocertifyScript' } | { __typename: 'CreatorOfMonth' } | { __typename: 'EduCourseListing' } | { __typename: 'FindYourSystem' } | { __typename: 'GetLook' } | { __typename: 'HtmlContent', contentTextAlign?: string | null, htmlContent?: { __typename?: 'HtmlContentHtmlContent', json: object, links: { __typename?: 'HtmlContentHtmlContentLinks', assets: { __typename?: 'HtmlContentHtmlContentAssets', block: Array<{ __typename?: 'Asset', contentType?: string | null, url?: string | null, title?: string | null, width?: number | null, height?: number | null, description?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename: 'HtmlImageContent' } | { __typename: 'InstagramEmbed' } | { __typename: 'MainHero' } | { __typename: 'ManualProductRecommendations' } | { __typename: 'ModuleArticleListing' } | { __typename: 'ModuleBlogHero' } | { __typename: 'ModuleEducationLink' } | { __typename: 'ModuleFeaturedArticles' } | { __typename: 'ModuleFeaturedTutorial' } | { __typename: 'ModuleHowToApply' } | { __typename: 'ModuleMeetEducators' } | { __typename: 'ModulePerks' } | { __typename: 'ModuleServiceEducationListing' } | { __typename: 'ModuleTestimonies' } | { __typename: 'ModuleVideoLesson' } | { __typename: 'NailArtSection' } | { __typename: 'NotFoundHero' } | { __typename: 'ShareYourLooks' } | { __typename: 'Shelf' } | { __typename: 'SliderHero' } | { __typename: 'VideoHero' } | null> } | null } | null> } | null };

export declare const staticPageHtml: import("graphql").DocumentNode;

export const StaticPageHtmlDocument = /*#__PURE__*/ `
    query staticPageHtml($handle: String!, $locale: String = "en-US", $preview: Boolean = false, $tagFilter: StaticPageFilter) {
  staticPageCollection(
    limit: 1
    locale: $locale
    preview: $preview
    where: {AND: [{handle: $handle}, $tagFilter]}
  ) {
    items {
      sectionsCollection(
        limit: 10
        preview: $preview
        where: {sys: {id_exists: true}}
      ) {
        __typename
        items {
          __typename
          ... on HtmlContent {
            ...HtmlContentFragment
          }
        }
      }
    }
  }
}
    ${HtmlContentFragmentDoc}`;
export const useStaticPageHtmlQuery = <
      TData = StaticPageHtmlQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: StaticPageHtmlQueryVariables,
      options?: UseQueryOptions<StaticPageHtmlQuery, TError, TData>
    ) =>
    useQuery<StaticPageHtmlQuery, TError, TData>(
      ['staticPageHtml', variables],
      fetcher<StaticPageHtmlQuery, StaticPageHtmlQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, StaticPageHtmlDocument, variables, options),
      options
    );

useStaticPageHtmlQuery.getKey = (variables: StaticPageHtmlQueryVariables) => ['staticPageHtml', variables];
;

useStaticPageHtmlQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: StaticPageHtmlQueryVariables, options?: RequestInit['headers']) => fetcher<StaticPageHtmlQuery, StaticPageHtmlQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, StaticPageHtmlDocument, variables, options);